import {
  getStoredPathMode,
  setStoredPathMode
} from "@pathwright/web/src/modules/path/utils"
import get from "lodash/get"
import { getAvailableModes as _getAvailableModes } from "../../library/show/components/path/withAvailableModes"
const Path = require("path/models/path").default
const PathItems = require("path/models/items").default
const PathItem = require("library/models/path-item").default
const modes = require("path/constants")

const getPathModeFromUrl = () => {
  const urlParams = new URLSearchParams(window.location.search)
  return urlParams.get("path_mode")
}

const removePathModeFromUrl = () => {
  const url = new URL(window.location.href)
  const params = new URLSearchParams(url.search)

  params.delete("path_mode")

  const newUrl = `${url.pathname}?${params.toString()}`
  window.history.replaceState({}, "", newUrl)
}

class PathStore extends require("lib/static-shim").default(
  require("lib/core/store/backbone-store").default
) {
  static initClass() {
    ;`\
Manages all data needed to render the a user's experience within a path\
`

    this.prototype.resources = {
      path: {
        model: Path
      },
      item: {
        model: PathItem,
        cache: false
      }
    }

    this.prototype.storeTriggers = {
      "path:step:selected"() {
        return this.get("selected_step")
      },
      "path:step:cleared"() {
        return null
      },
      "path:items:reordered"() {
        return this.get("path")
      },
      "path:loaded"() {
        return this.get("path")
      },
      "path:item:reset"() {
        return arguments
      }
    }

    this.prototype.storeTriggerHandlers = {
      auth: {
        "user:auth:changed"() {
          this.clearPersistentKeys()
          return this.action.setDefaultMode()
        }
      },
      step: {
        "update:step"(step) {
          return this.action.setPathItem(step.toJSON())
        },
        "set:step"(step) {
          return this.action.selectStep(step)
        }
      }
    }

    this.prototype.actions = {
      loadPath() {
        console.warn("pathStore.action.loadPath is deprecated")
      },

      loadNotes() {
        const { notes } = this.getStore("note").getState()
        const permissions = this.getStore("resource").request.permissions()
        if (!notes && permissions.can_access) {
          return this.getStore("note").action.loadAndGroupNotes()
        }
      },

      setDefaultMode() {
        this.action.setMode(this.request.getDefaultMode())
      },

      setDefaultExpanded() {
        // if not a student with a pre-selected group
        const { path } = this.getState()
        if (!this.request.getNextItem() && path && path.items.length < 30) {
          return this.action.expandAllGroups()
        }
      },

      setPath(pathData, forceUpdate) {
        // Bail out if this is the same path
        if (forceUpdate == null) {
          forceUpdate = false
        }

        const shouldSetPath =
          forceUpdate ||
          !this.get("path") ||
          !this.get("items") ||
          this.get("path").id !== pathData.id

        if (!shouldSetPath) return

        const { items, completion } = pathData

        const data = {
          path: pathData,
          items: new PathItems(items)
        }
        if (completion) {
          data.path_completion = completion
          data.user_has_completed = completion.progress_hundreds === 100
        }
        this._mutate(data)
        const { step_id, group_id } = this.attributes
        this.action.setDefaultExpanded()
        this.action.setDefaultMode()
        if (step_id && group_id) {
          this.action.setSelectedStepByID(step_id, group_id, true)
        }
        this.action.ensureNextStep()
        if (!this.get("selected_step")) {
          // Select the next step
          const next = this.request.getNextItem()
          if (next) {
            let silent
            this.action.setSelectedStep(next)
          }
        } else {
          const { sync_source_id: step_source_id, parent: parent_id } =
            this.get("selected_step").toJSON()
          const parent_source_id = get(
            this.request.getGroupById(parent_id),
            "sync_source_id"
          )
          // potentially clear the selected step and group if this step no longer exists in the path data
          this.action.setSelectedStepByID(
            step_source_id,
            parent_source_id,
            true
          )
        }
        this.action.loadNotes()
        this.storeTrigger("path:loaded")
      },

      ensureNextStep() {
        const nextStep = this.request.getNextItem()
        const { progress } = this.get("path_completion")
        let update = { progress }
        if (nextStep) {
          const next_group = __guard__(
            this.request.getGroupByStepId(nextStep.id),
            (x1) => x1.id
          )
          update = _.assign(update, { next_step: nextStep.id, next_group })
        }
        return this._mutate(update)
      },

      setSelectedStepByID(id, parentID, forceSet) {
        if (id) {
          let step = null
          if (this.get("selected_group")) {
            // does the selected group still exist in the path items?
            const sourceID = this.get("selected_group").get("sync_source_id")
            const group = this.request.getItemBySourceID(sourceID)
            if (group) {
              step = group.items.get(id)
            }
          }

          if (!step && parentID) {
            step = this.request.getItemBySourceID(id, parentID)
          }

          if (!step) {
            step = this.request.findStep(id)
          }

          if (step) {
            this.action.selectStep(step, forceSet)
          } else {
            if (
              this.get("selected_step") &&
              this.get("selected_step").id === id
            ) {
              this.action.clearSelectedStep()
            } else {
              console.warn(
                `Step with source id ${id} not found. Clearing selected step.`
              )
              this.action.clearSelectedStep()
            }
          }
        } else {
          this.action.clearSelectedStep()
        }
        return true
      },

      setSelectedStepByIndex(index, parentID) {
        const parent = this.request.getItemBySourceID(parentID)
        const step = parent.items.at(index)
        if (step) {
          return this.action.selectStep(step)
        }
      },

      selectStep(step, forceSet) {
        if (step.id !== __guard__(this.get("step"), (x) => x.id) || forceSet) {
          return this.action.setSelectedStep(step)
        }
      },

      setSelectedStep(step) {
        if (!this.get("items") || !step) {
          return
        }
        const update = {
          step,
          step_id: step.id,
          selected_step: step
        }
        const parent = step.get("parent")
        const group = this.request.getItemByID(parent)
        if (group) {
          /*
          * TEMP REMOVING EXPAND FOR SELECTED STEP
          expanded_groups = _.clone(@get("expanded_groups")) or []
          expanded_groups.push(group.id)
          update.expanded_groups = expanded_groups
          */
          update.selected_group = group
        }
        //@getStore("step").action.setStep(step)
        this._mutate(update)

        return this.storeTrigger("path:step:selected")
      },

      clearSelectedStep() {
        if (this.get("step")) {
          const url = this.computeURLForState()

          this._mutate({
            step: null,
            step_id: null,
            selected_step: null,
            selected_group: null
          })

          this.storeTrigger("path:step:cleared")

          const pathname =
            App.getStore("navigation").getState().location.pathname
          // HACK: only navigate if the current URL matches the current location in the navigation store (some other nagivation may be occurring - i.e. /completion/)
          if (url === pathname) {
            // navigate away from the cleared step
            App.navigate(this.computeURLForState())
          }
        }
      },

      togglePathExpanded(expanded) {
        const isSame = expanded === this.get("expanded")
        this._mutate({ expanded })
        if (isSame) {
          // Have to manually trigger
          return this.triggerChange("change:expanded", this)
        }
      },

      selectGroup(group) {
        const { selected_step } = this.getState()

        const mutation = {
          selected_group: group
        }

        // If we have a selected step but it doesn't belong to the group we're selecting
        // let's select the first step under the new group, if there is one.
        // This at least ensure's we don't retain a selected step for a previously
        // selected group.
        if (selected_step && selected_step.parent_id !== group.id) {
          mutation.selected_step = group?.items?.at(0) || null
        }

        return this._mutate(mutation)
      },

      selectGroupByID(groupID) {
        const group = this.request.getItemBySourceID(groupID)
        return this.action.selectGroup(group)
      },

      handleProgressAfterStepCompleteAction(item) {
        if (item.path.progress >= 1) {
          return this.action.showAchievement()
        }
      },

      showAchievement() {
        const { offering } = this.getStore("resource").getState()
        const toAchievement = {
          pathname: `${offering.url}achievement/`,
          state: { modal: true }
        }
        return this.getStore("navigation").action.navigate(toAchievement)
      },

      // Group collapse/expand
      expandGroup(groupSourceID) {
        const expanded_groups = _.clone(this.get("expanded_groups")) || []
        expanded_groups.push(groupSourceID)
        return this._mutate({ expanded_groups })
      },

      collapseGroup(groupSourceID) {
        let expanded_groups = _.clone(this.get("expanded_groups")) || []
        expanded_groups = _.without(expanded_groups, groupSourceID)
        return this._mutate({ expanded_groups })
      },

      toggleGroup(groupSourceID) {
        if (this.request.isGroupExpanded(groupSourceID)) {
          return this.action.collapseGroup(groupSourceID)
        } else {
          return this.action.expandGroup(groupSourceID)
        }
      },

      // Group steps collapse/expand

      expandGroupSteps(groupSourceID) {
        const expanded_group_steps =
          _.clone(this.get("expanded_group_steps")) || []
        expanded_group_steps.push(groupSourceID)
        return this._mutate({ expanded_group_steps })
      },

      collapseGroupSteps(groupSourceID) {
        let expanded_group_steps =
          _.clone(this.get("expanded_group_steps")) || []
        expanded_group_steps = _.without(expanded_group_steps, groupSourceID)
        return this._mutate({ expanded_group_steps })
      },

      toggleGroupSteps(groupSourceID) {
        if (this.request.areGroupStepsExpanded(groupSourceID)) {
          return this.action.collapseGroupSteps(groupSourceID)
        } else {
          return this.action.expandGroupSteps(groupSourceID)
        }
      },

      expandAllGroups() {
        const { items } = this.getState()
        const expanded_groups = items
          .filter((item) => item.item_type === "G")
          .map((g) => g.sync_source_id)

        this._mutate({ expanded_groups })
      },

      collapseAllGroups() {
        return this._mutate({ expanded_groups: [] })
      },

      setMode(mode) {
        if (mode !== this.get("mode")) {
          const { offering } = this.getStore("resource").getState()
          // only set the stored pathMode on non-curriculum paths
          if (offering && !offering.is_curriculum) {
            setStoredPathMode(mode)
          }
          // _previous_mode hack as this.previous("mode") seems to always equal this.get("mode")
          this._mutate({ mode, _previous_mode: this.get("mode") })
        }
      },

      exitViewAsLearner() {
        if (this.get("viewing_as_learner")) {
          this._mutate({
            viewing_as_learner: false
          })
          if (this.previous("mode")) {
            this.action.setMode(this.get("_previous_mode"))
          } else {
            this.action.setDefaultMode()
          }
        }

        // Exit out of preview prompt.
        if (this.get("viewing_as_learner_confirm")) {
          this._mutate({
            viewing_as_learner_confirm: false
          })
        }
      },

      viewAsLearner() {
        if (!this.get("viewing_as_learner")) {
          // When user has a Learner role, let's prompt them to confirm the view-as-learner action
          // before switching to preview mode.
          if (
            !this.get("viewing_as_learner_confirm") &&
            this.request.getAvailableModes().includes(modes.LEARN)
          ) {
            this._mutate({ viewing_as_learner_confirm: true })
          } else {
            // Otherwise, let's switch to preview mode with the Path Learn mode selected.
            this.action.setMode(modes.LEARN)
            this._mutate({
              viewing_as_learner: true,
              viewing_as_learner_confirm: false
            })
          }
        }
      },

      // Path item mutation actions synced to admin store (via store triggers)
      setPathItem(itemData, trigger) {
        if (trigger == null) {
          trigger = true
        }
        const { id, parent, item_type, sync_source_id } = itemData
        let passParent = parent
        if (item_type && item_type !== "A") {
          passParent = null
        }
        let item = this.request.getItemByID(id, passParent)
        if (!item) {
          // try to find by source id
          item = this.request.findItem(sync_source_id)
        }

        if (item) {
          item.set(itemData)
          if (trigger) {
            return this._triggerChangeEventsForItemUpdate(itemData)
          }
        } else {
          console.warn(
            `unable to set item data because item with ID ${id} was not found`,
            itemData
          )
          return console.trace()
        }
      }
    }

    this.prototype.requests = {
      getAvailableModes() {
        const permissions = this.getStore("resource").request.permissions()
        const { offering, registration } = this.getStore("resource").getState()
        const { viewing_as_learner } = this.getState()

        const availableModes = _getAvailableModes({
          permissions,
          offering,
          registration,
          viewing_as_learner
        })

        return availableModes
      },

      getDefaultMode() {
        const permissions = this.getStore("resource").request.permissions()
        const { offering } = this.getStore("resource").getState()
        const { path, items, viewing_as_learner } = this.getState()

        const availableModes = this.request.getAvailableModes()

        const currentMode = this.get("mode")
        const storedPathMode = getStoredPathMode()

        if (!permissions) return modes.PREVIEW
        if (viewing_as_learner) return modes.LEARN

        const urlPathMode = getPathModeFromUrl()
        if (urlPathMode && availableModes.includes(urlPathMode)) {
          removePathModeFromUrl()
          return urlPathMode
        }

        // only use the storedPathMode on non-curriculum paths
        if (
          !offering.is_curriculum &&
          availableModes.includes(storedPathMode)
        ) {
          return storedPathMode
        }

        // admin/editor loading personal path
        if (path && path.user && permissions.can_edit) {
          return modes.LEARN
        }

        if (permissions.can_edit) {
          if (offering.is_curriculum || (items && items.length < 1)) {
            return modes.DESIGN // design
          } else {
            return modes.TEACH // teach
          }
        }

        return currentMode || availableModes[0] || modes.PREVIEW
      },

      getPathStats() {
        const path = this.get("items")
        if (path) {
          const stats = _.reduce(
            path.models,
            (result, group) => {
              result.point_total += _.reduce(
                group.items.models,
                (sum, step) => {
                  sum += step.get("userpoints_value")
                  return sum
                },
                0
              )
              return result
            },
            { point_total: 0 }
          )
          return stats
        } else {
          return {}
        }
      },

      getGroupStats(groupID) {
        const group = this.get("items").get(groupID)
        if (group) {
          const step_count = group.items.models.length
          const stats = _.reduce(
            this._getSteps(group.items),
            (result, m) => {
              result.point_total += m.get("userpoints_value")
              result.progress += m.get("completion").progress
              result.time_to_complete += m.get("time_to_complete")
              return result
            },
            { point_total: 0, progress: 0, time_to_complete: 0 }
          )
          stats.step_count = step_count
          stats.progress = stats.progress / step_count
          return stats
        } else {
          return {}
        }
      },

      // returns the group or nearest step due date else null
      getDueDateForGroup(groupID) {
        const group = this.get("items").get(groupID)
        let dueDate = null

        const getHasDue = (item) => {
          const { due, progress } = item.toJSON()

          const isBefore = dueDate
            ? moment(due).isBefore(moment(dueDate))
            : !!due

          if (isBefore) {
            dueDate = due // side-effect
          }

          if (!due || progress === 1) {
            return false
          }
          return true
        }

        const hasDue = getHasDue(group) || group.items.models.find(getHasDue)

        if (hasDue) return dueDate

        return null
      },

      // returns the group or nearest step start date else null.
      getStartsDateForGroup(groupID) {
        const group = this.get("items").get(groupID)
        let startsDate = null

        const getIsLocked = (item) => {
          const { starts, passive_starts } = item.toJSON()

          if (starts && !passive_starts) {
            const isAfter = moment(starts).isAfter(moment())
            if (
              isAfter &&
              (!startsDate || moment(starts).isBefore(startsDate))
            ) {
              startsDate = starts
            }
            return isAfter
          }
          return false
        }

        const isLocked = getIsLocked(group) // || _.every(group.items.models, getIsLocked)

        if (isLocked) return startsDate

        // Check for path start locked date and return that if no start locked date was
        // found on the lesson.
        const { path } = this.getState()
        if (path.schedule?.start) {
          const { date, behavior } = path.schedule.start
          if (date && behavior === "lock" && moment(date).isAfter()) {
            return date
          }
        }

        return null
      },

      isGroupExpanded(groupSourceID) {
        if (this.get("expanded_groups") != null) {
          return Array.from(this.get("expanded_groups")).includes(groupSourceID)
        }
      },

      areGroupStepsExpanded(groupSourceID) {
        if (this.get("expanded_group_steps") != null) {
          return Array.from(this.get("expanded_group_steps")).includes(
            groupSourceID
          )
        }
      },

      getItemByID(itemID, parentID) {
        if (parentID == null) {
          parentID = null
        }
        const items = this.get("items")
        if (!items) {
          console.warn(
            "attempted to getItemByID without items set",
            itemID,
            parentID
          )
          return
        }
        if (parentID) {
          return __guard__(
            __guard__(items.get(parentID), (x1) => x1.items),
            (x) => x.get(itemID)
          )
        } else {
          return items.get(itemID)
        }
      },

      getItem(itemData) {
        const { id, parent } = itemData
        let items = this.get("items")
        if (parent) {
          ;({ items } = items.get(parent))
        }
        return items.get(id)
      },

      getItemBySourceID(sourceID, parentID) {
        if (parentID == null) {
          parentID = null
        }
        sourceID = parseInt(sourceID)
        let items = this.get("items")
        if (parentID) {
          const parent = items.get(parentID)
          if (parent) {
            items = parent.items
          }
        }
        return items.find((item) => item.get("sync_source_id") === sourceID)
      },

      findStep(stepID) {
        // Searches groups for steps
        stepID = parseInt(stepID)
        let step = null
        const items = this.get("items")
        const groups = items.filter((item) => item.get("item_type") === "G")
        for (let group of Array.from(groups)) {
          step = group.items.find(
            (step) => step.sourceID() === stepID || step.id === stepID
          )
          if (step) {
            return step
          }
        }
        if (!step) {
          step = items.find(
            (item) =>
              item.get("item_type") === "R" &&
              (item.sourceID() === stepID || item.id === stepID)
          )
        }
        return step
      },

      findItem(sourceID) {
        sourceID = parseInt(sourceID)
        let item = this.request.getItemBySourceID(sourceID) || null
        if (!item) {
          item = this.request.findStep(sourceID)
        }
        return item
      },

      getPathItemById(id, items) {
        // returns the step, group, or topic
        if (!items) {
          items = this.get("items")
        }

        for (
          let x = 0, end = items.length, asc = 0 <= end;
          asc ? x < end : x > end;
          asc ? x++ : x--
        ) {
          const item = items.at(x)
          if (item.id === id) {
            return item
          }
          if (item.items != null ? item.items.length : undefined) {
            const result = this.request.getPathItemById(id, item.items)
            if (result) {
              return result
            }
          }
        }
      },

      getPathContext() {
        const { resource, offering } = this.request.getContext()
        const userID = window.App.request("get:user").id
        return [resource, offering, userID]
      },

      getNextItem() {
        let nextStep = null
        const { resource } = this.getStore("resource").getState()
        const permissions = this.getStore("resource").request.permissions()
        const isCollection = resource.resource_type === 30
        if (!isCollection && get(permissions, "can_participate")) {
          const nextStepID = get(this.get("path_completion"), "next_step")
          if (nextStepID) {
            nextStep = this.request.getStepById(nextStepID)
          }
        }

        return nextStep
      },

      getStepAfter(stepID, parentID) {
        // Returns the next step after the given stepID
        const items = this.get("items")
        const group = items.get(parentID)
        const step = group.items.get(stepID)
        const index = group.items.indexOf(step)
        if (index < group.items.length - 1) {
          return group.items.at(index + 1)
        } else {
          return this.request.getNextGroup(parentID)
        }
      },

      getPrevGroup(groupID) {
        const selectedGroup = this.get("selected_group")
        if (!groupID && selectedGroup) {
          groupID = selectedGroup.id
        }

        const items = this.get("items")
        if (items) {
          const groups = items.filter((item) => item.get("item_type") === "G")
          const groupIndex = _.findIndex(groups, (g) => g.id === groupID)
          if (groupIndex > 0) {
            const prevGroup = groups[groupIndex - 1]
            return items.get(prevGroup.id)
          } else {
            return null
          }
        }
      },

      getNextGroup(groupID) {
        const selectedGroup = this.get("selected_group")
        if (!groupID && selectedGroup) {
          groupID = selectedGroup.id
        }

        const items = this.get("items")
        if (items) {
          const groups = items.filter((item) => item.get("item_type") === "G")
          const groupIndex = _.findIndex(groups, (g) => g.id === groupID)
          if (groupIndex < groups.length - 1) {
            const nextGroup = groups[groupIndex + 1]
            return items.get(nextGroup.id)
          } else {
            return null
          }
        }
      },

      getNextStepForGroup(groupID) {
        const items = this.get("items")
        const group = items.get(groupID)
        const steps = this._getSteps(group.items)
        let nextStep = steps.find((step) => step.get("completion").progress < 1)
        // if all steps are complete, return the first one
        if (!nextStep && group.items.length) {
          nextStep = group.items.at(0)
        }
        return nextStep
      },

      getContext() {
        const resourceStore = window.App.stores.requestStore("resource")
        const { resource, offering } = resourceStore.getState()
        const path = this.get("path")
        const step = this.get("step")
        const ctx = {
          resource: resource != null ? resource.id : undefined,
          offering: offering != null ? offering.id : undefined,
          path: path != null ? path.id : undefined,
          step: step != null ? step.sourceID() : undefined
        }
        return ctx
      },

      getLegacyContext() {
        const context = this.request.getContext()
        return {
          step: context.step,
          course: context.resource,
          class: context.offering
        }
      },

      getURLForStep(step) {
        if (step.toJSON != null) {
          step = step.toJSON()
        }
        const { path } = this.getState()
        const baseURL = path.url
        const step_url = `${baseURL}step/${step.sync_source_id}/`
        return step_url
      },

      // helper functions
      getGroupById(id) {
        const path = this.get("items")
        const group = path.get(id)
        return group
      },

      getGroupByStepId(id) {
        const path = this.get("items")
        const group = path.filter((i) => i.items.get(id))
        return _.first(group)
      },

      getStepById(id) {
        const group = this.request.getGroupByStepId(id)
        if (group && group.items) {
          const step = group.items.get(id)
          return step
        } else {
          // TODO: figure out why this case is happening
          console.warn("get step by id because group is undefined", id)
          return null
        }
      },

      getStepIndexById(id) {
        const group = this.request.getGroupByStepId(id)
        const step = this.request.getStepById(id)
        const index = group.items.indexOf(step)
        return index
      },

      getGroupIndexById(id) {
        const path = this.get("items")
        const group = this.request.getGroupById(id)
        const index = path.indexOf(group)
        return index
      }
    }
  }

  defaults() {
    // API/data state
    return {
      path: null, // Path
      step: null, // Step
      next_step: null,
      next_group: null,
      path_completion: null, // The path progress/completion info (if any)
      step_id: null, // the selected step_id
      group_id: null, // the selected step_id
      user_has_completed: false, // TODO: phase out – using path_completion instead
      items: null, // Root-level path items,

      // UI states
      expanded_groups: [], // a list of group ids that are expanded
      expanded_group_steps: [], // a list of groups with their steps expanded
      mode: null, // PREVIEW (0), LEARN (5), TEACH (10), DESIGN (15)
      expanded: true, // are all groups expanded
      selected_group: null, // the selected group state on the path
      selected_step: null, // the step on the path
      viewing_as_learner: false,
      viewing_as_learner_confirm: false // prompt user to confirm viewing_as_learner change
    }
  }

  // Add user specificity for persistent keys
  _specifyUserForPersistentKey(key) {
    const authStore = this.getStore("auth")
    if (authStore.request.isAuthenticated()) {
      const user_id = authStore.getState().user.id
      key = `${key}:${user_id}`
    }
    return key
  }

  _getSearchItems(itemData) {
    const { id, parent, item_type } = itemData
    let { items } = this.attributes
    if (item_type === "A" && parent) {
      ;({ items } = items.get(parent))
    }
    return items
  }

  _getSteps(items) {
    return items.filter((item) => item.get("item_type") === "A")
  }

  _triggerChangeEventsForItemUpdate(itemData) {
    this.triggerChange("change:path")
    if (itemData) {
      return this.storeTrigger("path:item:reset", itemData)
    }
  }

  bootstrapStore(bd) {
    if (bd.path) {
      return this.action.setPath(bd.path)
    }
  }

  computeURLForState() {
    let step
    ;`\
Returns a URL matching the user's existing state within the path\
`
    let path = this.get("path")
    ;({ path, step } = this.getState())
    let url = ""
    if (path) {
      if (step) {
        ;({ url } = step)
      } else {
        ;({ url } = path)
      }
    }
    return url
  }
}
PathStore.initClass()

export default window.App.stores.registerStore("path", PathStore)

function __guard__(value, transform) {
  return typeof value !== "undefined" && value !== null
    ? transform(value)
    : undefined
}
